import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaLaptopCode, FaShoppingCart, FaPhoneVolume } from "react-icons/fa";
import "../css/SupportStore.css";

const SupportStore = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  const storeCampaigns = [
    {
      id: 1,
      leftBannerImg: "../images/Education_Funds.png",
      leftHeading: "Support Sahara Public Secondary School",
      leftSubText:
        "Your donation funds higher education and digital infrastructure development for rural talent.",
      rightArrivalTag: "FEATURED SOFTWARE",
      rightProductTitle: "Smart School ERP System",
      rightProductSub:
        "Manage attendance, fees, online exams, report cards, and live classes in one secure dashboard.",
      rightPrice: "Free Demo Available",
      icon: <FaLaptopCode />,
      productLink: "/contact",
    },
    {
      id: 2,
      leftBannerImg: "../images/Education_Funds1.png",
      leftHeading: "Empower Your Local Business",
      leftSubText:
        "We build high-performance software and mobile apps tailored for institutional growth.",
      rightArrivalTag: "PREMIUM SOLUTION",
      rightProductTitle: "Custom E-Commerce Apps",
      rightProductSub:
        "Launch your online store with delivery tracking, localized secure payments, and inventory analytics.",
      rightPrice: "Boost Your Sales",
      icon: <FaShoppingCart />,
      productLink: "/contact",
    },
    {
      id: 3,
      leftBannerImg: "../images/Education_Funds2.png",
      leftHeading: "Next-Gen Communication Infrastructure",
      leftSubText:
        "Bridge the gap between parents, teachers, and administration with automated smart setups.",
      rightArrivalTag: "CLOUD TELEPHONY",
      rightProductTitle: "Bulk SMS & Cloud Calling",
      rightProductSub:
        "Automated IVR systems, instantaneous notification alerts, and smart cloud attendance routing.",
      rightPrice: "Instant Setup",
      icon: <FaPhoneVolume />,
      productLink: "/contact",
    },
  ];

  useEffect(() => {
    const slideTimer = setInterval(() => {
      setActiveSlide((prevIndex) =>
        prevIndex === storeCampaigns.length - 1 ? 0 : prevIndex + 1,
      );
    }, 5000);

    return () => clearInterval(slideTimer);
  }, [storeCampaigns.length]);

  return (
    <div className="store-page-root">
      <main className="split-view-slider-matrix">
        {storeCampaigns.map((slide, index) => {
          const isCurrent = index === activeSlide;
          return (
            <div
              key={slide.id}
              className={`split-slide-row ${isCurrent ? "view-active" : "view-hidden"}`}
              style={{ display: isCurrent ? "flex" : "none" }}
            >
              {}
              <div
                className="left-interactive-hero-panel"
                style={{
                  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.65)), url(${slide.leftBannerImg})`,
                }}
              >
                <div className="left-inner-animated-content">
                  <h2 className="left-main-showcase-title">
                    {slide.leftHeading}
                  </h2>
                  <p className="left-showcase-caption-text">
                    {slide.leftSubText}
                  </p>
                </div>
              </div>

              {}
              <div className="right-ecommerce-product-panel">
                <div className="right-inner-animated-content">
                  <div className="ad-header-flex">
                    <span className="product-tag-label-badge">
                      {slide.rightArrivalTag}
                    </span>
                    <div className="ad-software-icon">{slide.icon}</div>
                  </div>

                  <h3 className="product-main-display-title">
                    {slide.rightProductTitle}
                  </h3>
                  <p className="product-marketing-description">
                    {slide.rightProductSub}
                  </p>

                  <div className="product-pricing-figure-block">
                    {slide.rightPrice}
                  </div>

                  <Link
                    to={slide.productLink}
                    className="btn btn-primary"
                  >
                    GET A QUOTE / VIEW DETAILS
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </main>
    </div>
  );
};

export default SupportStore;
